import React from 'react'
import cx from 'classnames'
import styles from './IndividualizationButton.module.css'

const IndividualizationButton: React.FC<{
    text: string
    text_color: string
    background_color: string
    icon_color: string
    classes: string
}> = ({ text, text_color, background_color, icon_color, classes }) => {
    return (
        <button
            className={cx(styles['individualization-button'], classes)}
            type={'button'}
            style={{ color: text_color, backgroundColor: background_color }}
        >
            <svg
                className={'zr-mr-2'}
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 32 32"
                width={'2rem'}
                xmlSpace="preserve"
            >
                <g>
                    <path
                        fill={icon_color}
                        d="M22.7,14.7c-0.9,0-1.7,0.1-2.5,0.4L12.3,1.3c-0.2-0.3-0.5-0.5-0.9-0.5c-0.4,0-0.7,0.2-0.9,0.5L1.4,16.2
                            c-0.2,0.3-0.2,0.7,0,1l3.9,6.2c-0.2,0-0.4,0.1-0.6,0.3c-0.2,0.2-0.3,0.4-0.3,0.7l-0.1,5c0,0.6,0.4,1,1,1l11.4,0.2c0,0,0,0,0,0
                            c0.3,0,0.5-0.1,0.7-0.3c0.2-0.2,0.3-0.4,0.3-0.7l0-0.8c1.4,1.1,3.1,1.8,5,1.8c4.4,0,8-3.6,8-8C30.7,18.2,27.1,14.7,22.7,14.7z
                             M11.2,15c0.4,0,0.7,0.2,0.9,0.4c0.5,0.6,0.5,1.5,0,2.1c-0.3,0.3-0.6,0.4-1,0.4c-0.3,0-0.7-0.2-0.9-0.4c-0.5-0.6-0.5-1.5,0-2.1
                            C10.5,15.1,10.8,14.9,11.2,15z M15.7,28.7l-9.4-0.2l0.1-3l8.9,0.2c0.1,0.3,0.3,0.7,0.5,1L15.7,28.7z M14.7,22.7c0,0.2,0,0.4,0,0.7
                            l-0.1,0.1l-7-0.1l-4.1-6.6l6.9-11.3v7.6c-0.6,0.1-1.1,0.4-1.5,0.9c-0.7,0.7-1,1.6-1,2.5c0,0.8,0.3,1.7,0.9,2.4
                            c0.6,0.7,1.5,1,2.4,1.1h0.1c0.9,0,1.7-0.3,2.3-1c1.3-1.3,1.4-3.5,0.1-4.8c-0.3-0.4-0.8-0.7-1.2-0.8V5.5l5.9,10.5
                            C16.1,17.4,14.7,19.8,14.7,22.7z M26.7,23.3h-3.3v3.4H22v-3.4h-3.3v-1.2H22v-3.4h1.3v3.4h3.3V23.3z"
                    />
                </g>
            </svg>
            {text}
        </button>
    )
}

export default IndividualizationButton
